var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flueid-Pro-2.0-Website-Public-Home-Expanded",
    transform: "translate(-1490, -6675)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0, 6431)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 0)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1034, 204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.1875,55 C443.1875,61.7324219 437.732422,67.1875 431,67.1875 C430.753906,67.1875 430.513672,67.1816406 430.273438,67.1640625 L429.869141,68.3710938 C429.669922,68.9746094 429.347656,69.4726562 428.955078,69.859375 C429.623047,69.953125 430.302734,70 431,70 C439.285156,70 446,63.2851562 446,55 C446,46.7148438 439.285156,40 431,40 C422.714844,40 416,46.7148438 416,55 C416,55.6914062 416.046875,56.3769531 416.140625,57.0449219 C416.527344,56.6523438 417.025391,56.3359375 417.628906,56.1308594 L418.835938,55.7265625 C418.824219,55.4863281 418.8125,55.2460938 418.8125,55 C418.8125,48.2675781 424.267578,42.8125 431,42.8125 C437.732422,42.8125 443.1875,48.2675781 443.1875,55 Z M439.5,54.9588113 C439.5,50.2888425 435.711157,46.5 431.041189,46.5 C426.547445,46.5 422.870212,50.0068822 422.6,54.4360097 L425.613452,53.4315259 C426.277233,51.0583594 428.456552,49.3196038 431.041189,49.3196038 C434.154501,49.3196038 436.680396,51.8454988 436.680396,54.9588113 C436.680396,57.543448 434.941641,59.7227668 432.568474,60.3865485 L431.56399,63.4 C435.993118,63.129788 439.5,59.4525547 439.5,54.9588113 Z M430.952657,56.2341376 C431.063719,55.8950554 430.976039,55.526742 430.724688,55.2753535 C430.473338,55.023965 430.10508,54.9362713 429.766049,55.04735 L418.542954,58.7889464 C418.163005,58.9175638 417.90581,59.2741847 417.90581,59.6775756 C417.90581,60.0809665 418.163005,60.4375874 418.542954,60.5662047 L422.225532,61.7939161 L416.912098,67.1081523 C416.362634,67.6576993 416.362634,68.5463284 416.912098,69.0900292 C417.461562,69.6337299 418.350057,69.6395762 418.893676,69.0900292 L424.20711,63.775793 L425.434636,67.458927 C425.563234,67.8389329 425.919801,68.0961676 426.323131,68.0961676 C426.726461,68.0961676 427.083028,67.8389329 427.211626,67.458927 L430.952657,56.2341376 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSource);
export default __webpack_public_path__ + "static/media/multi-source.de09dc1a84dd0717f2379a58da63b8f9.svg";
export { ForwardRef as ReactComponent };